/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     设备增值-授权CIOT管理 API
  | @Version:   2020-03-09  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from "@/utils/request";

export function ciotListApi(query) {
  return request({
    url: "?c=ei&a=ciot&do=list",
    method: "get",
    params: query
  });
}

export function ciotTicketApi() {
  return request({
    url: "?c=ei&a=ciot&do=getavailable",
    method: "get"
  });
}

export function ciotProductApi() {
  return request({
    url: "?c=ei&a=ciot&do=getproduct",
    method: "get"
  });
}

export function createCiotApi(data) {
  return request({
    url: "?c=ei&a=ciot&do=create",
    method: "post",
    data: data
  });
}

export function postCiotApi(data) {
  return request({
    url: "?c=ei&a=ciot&do=post",
    method: "post",
    data: data
  });
}

export function copyurlCiotApi(data) {
  return request({
    url: "?c=ei&a=ciot&do=copyurl",
    method: "post",
    data: data
  });
}

export function promoteCiotApi(data) {
  return request({
    url: "?c=ei&a=ciot&do=promote",
    method: "post",
    data: data
  });
}

export function preBindCiotApi(data) {
  return request({
    url: "?c=ei&a=ciot&do=prebind",
    method: "post",
    data
  });
}
